document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const form = select.closest('form');
      const idInput = form && form.querySelector('input[name="id"]');
      if (idInput) idInput.value = option.value;
      const priceTarget = document.querySelector('[data-product-price]');
      if (priceTarget && option.dataset.price) priceTarget.textContent = option.dataset.price;
    });
  });
});
